/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountVerificationStatus } from './BankAccountVerificationStatus';
import {
    BankAccountVerificationStatusFromJSON,
    BankAccountVerificationStatusFromJSONTyped,
    BankAccountVerificationStatusToJSON,
    BankAccountVerificationStatusToJSONTyped,
} from './BankAccountVerificationStatus';

/**
 * 
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bankName: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    lastFourDigits: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    stripePaymentMethodId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccount
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    institutionNumber: string;
    /**
     * 
     * @type {BankAccountVerificationStatus}
     * @memberof BankAccount
     */
    verificationStatus: BankAccountVerificationStatus;
    /**
     * Stripe SetupIntent id when verificationStatus is PendingVerification; absent otherwise.
     * @type {string}
     * @memberof BankAccount
     */
    setupIntentId?: string;
    /**
     * Expected arrival date for the micro-deposits (PendingVerification only).
     * @type {Date}
     * @memberof BankAccount
     */
    microdepositArrivalDate?: Date;
}



/**
 * Check if a given object implements the BankAccount interface.
 */
export function instanceOfBankAccount(value: object): value is BankAccount {
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('lastFourDigits' in value) || value['lastFourDigits'] === undefined) return false;
    if (!('stripePaymentMethodId' in value) || value['stripePaymentMethodId'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('institutionNumber' in value) || value['institutionNumber'] === undefined) return false;
    if (!('verificationStatus' in value) || value['verificationStatus'] === undefined) return false;
    return true;
}

export function BankAccountFromJSON(json: any): BankAccount {
    return BankAccountFromJSONTyped(json, false);
}

export function BankAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'bankName': json['bankName'],
        'lastFourDigits': json['lastFourDigits'],
        'stripePaymentMethodId': json['stripePaymentMethodId'],
        'isDefault': json['isDefault'],
        'institutionNumber': json['institutionNumber'],
        'verificationStatus': BankAccountVerificationStatusFromJSON(json['verificationStatus']),
        'setupIntentId': json['setupIntentId'] == null ? undefined : json['setupIntentId'],
        'microdepositArrivalDate': json['microdepositArrivalDate'] == null ? undefined : (new Date(json['microdepositArrivalDate'])),
    };
}

  export function BankAccountToJSON(json: any): BankAccount {
      return BankAccountToJSONTyped(json, false);
  }

  export function BankAccountToJSONTyped(value?: BankAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bankName': value['bankName'],
        'lastFourDigits': value['lastFourDigits'],
        'stripePaymentMethodId': value['stripePaymentMethodId'],
        'isDefault': value['isDefault'],
        'institutionNumber': value['institutionNumber'],
        'verificationStatus': BankAccountVerificationStatusToJSON(value['verificationStatus']),
        'setupIntentId': value['setupIntentId'],
        'microdepositArrivalDate': value['microdepositArrivalDate'] == null ? undefined : ((value['microdepositArrivalDate']).toISOString().substring(0,10)),
    };
}

